export interface Statistics {
    hero: {
      years: string
      projects: string
      uptime: string
      performance: string
    }
    expertise: {
      name: string
      percentage: number
    }[]
    about: {
      technologies: string
      projects: string
      satisfaction: string
    }
  }
  
  export const statistics: Statistics = {
    hero: {
      years: "6+",
      projects: "20+",
      uptime: "99.9%",
      performance: "70%"
    },
    expertise: [
      {
        name: "Full-Stack Development",
        percentage: 95
      },
      {
        name: "React & Next.js",
        percentage: 92
      },
      {
        name: "Python Backend (Flask/Django)",
        percentage: 90
      },
      {
        name: "Cloud Infrastructure",
        percentage: 88
      },
      {
        name: "CI/CD & Automation",
        percentage: 85
      }
    ],
    about: {
      technologies: "10+",
      projects: "15+",
      satisfaction: "100%"
    }
  }